export enum CurrentTab { FORM, SORT, FILTER };

export enum CustomQuerySource { NEW_CQ, DROPDOWN_LIST, EDIT, SAVE_AS, NO_CQ };

export enum ConfirmType { CLOSED, OPEN_BECAUSE_APPLY, OPEN_BECAUSE_CHANGE_TAB_TO_SORT, OPEN_BECAUSE_CHANGE_TAB_TO_FORM };

export enum ErrorType { NONE, DUPLICATE, INVALID }